module.exports = __webpack_public_path__ + "media/banner/banner-01-968bbfa5.jpg";